<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-btn
          text
          x-small
          :disabled="!fileId"
          v-on="on"
          v-on:click="previewFile"
        >
          <v-icon>mdi-file-eye-outline</v-icon>
        </v-btn>
      </span>
    </template>
    <span>{{ title }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["fileId"],
  computed: {
    title: function () {
      return this.fileId
        ? "Preview Report"
        : "Formatted PDF report unavailable to preview.";
    },
  },
  methods: {
    previewFile: async function () {
      this.$store.commit("uxModule/setShowLoader", true);
      var fileUrl = await this.$store.dispatch(
        "filesModule/getFileUrl",
        {
          fileId: this.fileId,
        }
      );
      this.$store.commit("uxModule/setShowLoader", false);

      if (fileUrl) {
        window.open(fileUrl);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>